import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useTranslation } from '../../../../hooks/useTranslation';
import { ValidatedSingleGeoLocationValueInputProps } from '../types';

export const SingleGeoLocationInput = ({
  comparator,
  dataType,
  field,
  fieldType,
  isInvalid,
  hasWarning,
  onChange,
  value,
}: ValidatedSingleGeoLocationValueInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueSingleGeoLocationValue: VisualComponent } = useVisualComponentsContext();

  const isDisabled = !!isReadOnly;
  const hasError = !!isInvalid;

  return (
    <VisualComponent
      comparator={comparator}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      hasError={hasError}
      hasWarning={hasWarning}
      isDisabled={isDisabled}
      onChange={onChange}
      placeholder={t('v2.conditionBuilder.singleGeoLocationPlaceholder')}
      value={value}
    />
  );
};
